/* eslint-disable react/no-unknown-property */
import React, { Fragment, useState } from 'react';

import classNames from 'classnames';
import { Icon, Button } from 'components/ClubComponents';
import { I18n } from 'components/translate';
import {
  EVENT_ACTIONS,
  EVENTS_INTERACTIONS,
  EVENTS_CATEGORY
} from 'modules/app/services/datahub/constants';
import DatahubService from 'modules/app/services/datahub/DatahubService';
import { buildInteractionEventData } from 'modules/app/services/datahub/helper';
import * as GA from 'modules/app/services/ga/constants';
import GtagService from 'modules/app/services/ga/GtagService';
import { MembershipEventService } from 'modules/membershipEvent';
import { EVENTS } from 'modules/membershipEvent/constants';

import { STEPS, STEPS_INFO, FORWARD_LABEL } from './constants';

import './ClubLiveOnboarding.scss';

const ClubLiveOnboarding = () => {
  const [stepActive, setStepActive] = useState(STEPS.STEP1);
  const [closed, setClosed] = useState(false);

  const sendEvent = (label) => {
    GtagService.sendEvent({
      event: GA.EVENTS.INTERACTION,
      category: GA.CATEGORIES.CLUB_ADMIN_MODAL,
      action: GA.ACTIONS.CLICK,
      where: `${GA.ACTIONS.NOTIFICATION_LIVE.LIVE_ONBOARDING_CARD}-${stepActive}`,
      label
    });

    DatahubService.sendEvent({
      action: EVENT_ACTIONS.INTERACT,
      event: buildInteractionEventData({
        category: `${EVENTS_CATEGORY.CONTENT.CONTENT_LIVE.LIVE_ONBOARDING_CARD}${stepActive}`,
        action: EVENTS_INTERACTIONS.CLICK,
        label
      })
    });
  };

  const onDisable = (label) => {
    sendEvent(label);
    setClosed(true);
    MembershipEventService.dismissEvent(EVENTS.ONBOARDING_LIVE);
  };

  const setNextStep = () => {
    if (stepActive === STEPS.STEP3) {
      onDisable(GA.LABELS.FINISH);
    } else {
      sendEvent(GA.LABELS.NEXT);
      setStepActive(stepActive + 1);
    }
  };

  const setLastStep = () => {
    if (stepActive !== STEPS.STEP1) {
      sendEvent(GA.LABELS.PREVIOUS);
      setStepActive(stepActive - 1);
    }
  };

  const renderCards = () => {
    return STEPS_INFO.flatMap((item) => {
      return (
        item.id === stepActive && (
          <Fragment key={item.id}>
            <div className="notification__live__onboarding__header">
              <button
                className="notification__live__onboarding__close"
                onClick={() => onDisable(GA.LABELS.CLOSE)}
              >
                <Icon name="times-circle" size={14} />
              </button>
              <img
                className="notification__live__onboarding__banner"
                src={item.image}
                alt={item.title}
              />
            </div>
            <div className="notification__live__onboarding__body">
              <span className="notification__live__onboarding__title">
                <I18n label={item.title} />
              </span>

              <p className="notification__live__onboarding__text">
                <I18n label={item.description} />
              </p>
            </div>
          </Fragment>
        )
      );
    });
  };

  const renderSlider = () => {
    return (
      <div className="notification__live__onboarding__slider">
        {STEPS_INFO.map((item, index) => {
          const isActive = item.id === stepActive;

          return (
            <span
              key={`slider-dot-${index}`}
              className={classNames(
                'notification__live__onboarding__slider__dot',
                { active: isActive }
              )}
            ></span>
          );
        })}
      </div>
    );
  };

  const renderActions = () => {
    return (
      <div className="notification__live__onboarding__actions">
        {stepActive !== STEPS.STEP1 && (
          <button
            className="notification__live__onboarding__btn notification__live__onboarding__btn-close"
            outline
            size={Button.SIZE.SMALL}
            onClick={setLastStep}
          >
            <I18n label="general.back" />
          </button>
        )}

        <Button.Primary
          className="notification__live__onboarding__btn"
          size={Button.SIZE.SMALL}
          onClick={setNextStep}
        >
          <I18n label={FORWARD_LABEL[stepActive]} />
        </Button.Primary>
      </div>
    );
  };

  return (
    !closed && (
      <div className="notification__live__onboarding">
        {renderCards()}
        <div className="notification__live__onboarding__footer">
          {renderSlider()}
          {renderActions()}
        </div>
      </div>
    )
  );
};

export default ClubLiveOnboarding;
